<template>
	<div>
		<div class="d-flex flex-column align-center width-full">
			<h2 class="text-title-s d-flex align-self-start mb-2">
				{{ $t('Common_Profile_Title_Cover_Photo') }}
			</h2>
			<div class="width-full">
				<Cover
					v-if="!imageUrl"
					class="rounded-3 width-full"
					:src="defaultCover"
					:style="{ height }"
				/>
				<Cover v-else :src="imageUrl" :lazy="false" class="rounded-3 width-full" :height="height" />
			</div>
			<InputFile
				class="py-2"
				:button-text="$t('Profile_Owner_Edit_Cover_picture')"
				@change="uploadImage"
			/>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed } from 'vue'
	import { ProfileActions } from '~/actions/profile/action'
	import defaultCover from '~/assets/profile/background_profile_mobile.png'

	interface Props {
		picture?: string
		isXS: boolean
	}

	const props = defineProps<Props>()
	const emit = defineEmits(['change'])

	const imageUrl = ref<string | undefined>(props.picture)

	const uploadImage = async (file: File): Promise<void> => {
		const media = await ProfileActions.uploadAvatar(file)
		imageUrl.value = URL.createObjectURL(file)
		emit('change', { id: media?.id, url: imageUrl.value })
	}

	const height = computed(() => (props.isXS ? '170px' : '160px'))
</script>
